import {Tabs, withStyles} from '@material-ui/core';
import {SWITCH_BORDER_COLOR} from '../../../style/variable';
const InvoicesStyledTabs = withStyles({
  root: {
    minHeight: '35px'
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: SWITCH_BORDER_COLOR,
    height: '0.2rem',
    borderTopLeftRadius: '3pt',
    borderTopRightRadius: '3pt',
    '& >span': {
      maxWidth: 40,
      width: '100%'
    }
  },
  scroller: {
    display: 'flex'
  }
})(Tabs);

export default InvoicesStyledTabs;
